import {
  INSTAGRAM_CAPTION_LIMIT,
  INSTAGRAM_CAPTION_MARKS,
  INSTAGRAM_FEED_RENDITION,
  INSTAGRAM_REEL_CAPTION_LIMIT,
  instagramCarouselAspect,
  instagramFrameAspect,
  instagramHandle,
} from '../../../../lib/instagram-post-preview';
import { POST_PLAIN_MARKS } from '../../../../lib/social-post-look-parts';
import { MediaCarousel, PostAvatar, PostCaption, PostTiming, TallPost, type SocialPostLookProps } from './SocialPostLookParts';
import styles from './InstagramPostPreview.module.css';

export function InstagramFeedPost({ card, onOpenMedia, onToggleCaption }: SocialPostLookProps) {
  return (
    <>
      <header className={styles.header}>
        <PostAvatar card={card} name={instagramHandle(card)} size={24} />
        <span className={styles.handle} data-testid="instagram-handle">
          <bdi>{instagramHandle(card)}</bdi>
        </span>
      </header>
      <MediaCarousel
        card={card}
        rendition={INSTAGRAM_FEED_RENDITION}
        aspectOf={card.media.length > 1 ? instagramCarouselAspect : instagramFrameAspect}
        className={styles.media}
        testId="instagram-media"
        lightSteps
        onOpen={onOpenMedia}
      />
      {card.caption && (
        <div className={styles.captionBlock}>
          <span className={styles.captionHandle} data-testid="instagram-caption-handle">
            <bdi>{instagramHandle(card)}</bdi>
          </span>
          <PostCaption
            caption={card.caption}
            className={styles.caption}
            testId="instagram-caption"
            cut={{ limit: INSTAGRAM_CAPTION_LIMIT }}
            marks={INSTAGRAM_CAPTION_MARKS}
            onToggle={onToggleCaption}
          />
        </div>
      )}
      <span className={styles.when} data-testid="instagram-when">
        <PostTiming card={card} />
      </span>
    </>
  );
}

export function InstagramReel(props: SocialPostLookProps) {
  return (
    <TallPost
      {...props}
      kind="reel"
      name={instagramHandle(props.card)}
      nameTestId="instagram-handle"
      frameTestId="instagram-reel"
      captionTestId="instagram-caption"
      captionLimit={INSTAGRAM_REEL_CAPTION_LIMIT}
      marks={POST_PLAIN_MARKS}
    />
  );
}

export function InstagramStory(props: SocialPostLookProps) {
  return <TallPost {...props} kind="story" name={instagramHandle(props.card)} nameTestId="instagram-handle" frameTestId="instagram-story" />;
}
